const mappingKhmerNumber = (input) => {
	const mapping = {
		0: '០',
		1: '១',
		2: '២',
		3: '៣',
		4: '៤',
		5: '៥',
		6: '៦',
		7: '៧',
		8: '៨',
		9: '៩',
	};
	const numbers = input.toString().split('');
	const n = numbers.map((e) => mapping[e] ?? e);
	return n.join('');
};

const mappingKhmerNumberDecimal = (input) => {
	const mapping = {
		0: '០',
		1: '១',
		2: '២',
		3: '៣',
		4: '៤',
		5: '៥',
		6: '៦',
		7: '៧',
		8: '៨',
		9: '៩',
		'.': '.',
	};

	return input
		.toString()
		.split('')
		.map((char) => mapping[char] ?? char)
		.join('');
};

const isNumeric = (value) => {
	const numberRegex = /^[-+]?[0-9]*(\.[0-9]+)?([eE][+-]?\d+)?$/;
	return numberRegex?.test(value?.toString() || null);
};

const validateSpreadsheet = (spreadsheetData) => {
	let isValid = true;
	spreadsheetData?.forEach((row) => {
		row?.forEach((column) => {
			if (!isNumeric(column?.value)) {
				isValid = false;
			}
		});
	});
	return isValid;
};

const validateSpreadsheets = (spreadsheets) => {
	let isValid = true;
	spreadsheets?.forEach((sheet) => {
		sheet?.forEach((row) => {
			row?.forEach((col) => {
				if (!isNumeric(col?.value)) {
					isValid = false;
				}
			});
		});
	});
	return isValid;
};

function checkSelectedActiveRow(active, index, t) {
	if (active?.row === index && t === active?.t) {
		return true;
	}
	return false;
}

function checkSelectedActiveColumn(active, index) {
	if (active?.column === index) {
		return true;
	}
	return false;
}

function cleanSpreadsheet(numRow, numColumn) {
	return [
		...Array(numRow)
			.keys()
			.reduce((p, c) => {
				let arr = p;
				arr.push([
					...Array(numColumn)
						.keys()
						.reduce((p, c) => {
							let arr = p;
							arr.push({ value: '' });
							return arr;
						}, []),
				]);
				return arr;
			}, []),
	];
}

const saleReportTypes = [
	{ labelKh: 'បុគ្គល', labelEn: 'Individual', value: 'Individual' },
	{ labelKh: 'ក្រុម', labelEn: 'Group', value: 'Group' },
	{ labelKh: 'ការវិនិយោគ', labelEn: 'Investment', value: 'Investment' },
	{ labelKh: 'កាតព្វកិច្ច', labelEn: 'MTPL', value: 'MTPL' },
];

const mappingCompanyType = { GENERAL_INSURANCE: 'General', LIFE_INSURANCE: 'Life', MICRO_INSURANCE: 'Micro' };

const mappingTypeOfReport = { GENERAL_INSURANCE: 'General', LIFE_INSURANCE: 'Life', MICRO_INSURANCE: 'Micro' };

const isDataViewer = ({ user, companyType }) => {
	// mddgmr
	// mddlmr
	// mddmmr
	// mmdcd
	// mmdrd
	// mddcae
	if (!user) return false;
	if (!companyType) return false;
	const roles = user?.role.split(',') || [];
	if (roles?.includes('admin')) return true;
	if (companyType === 'General' && roles?.includes('mdd') && user?.mdd?.includes('mddgmr') && user?.mdd?.includes('mmdrd')) {
		return true;
	} else if (companyType === 'Life' && roles?.includes('mdd') && user?.mdd?.includes('mddlmr') && user?.mdd?.includes('mmdrd')) {
		return true;
	} else if (companyType === 'Micro' && roles?.includes('mdd') && user?.mdd?.includes('mddmmr') && user?.mdd?.includes('mmdrd')) {
		return true;
	} else {
		return false;
	}
};

const isConViewer = ({ user, companyType }) => {
	// mddgmr
	// mddlmr
	// mddmmr
	// mmdcd
	// mmdrd
	// mddcae
	if (!user) return false;
	if (!companyType) return false;
	const roles = user?.role.split(',') || [];
	if (roles?.includes('admin')) return true;
	if (companyType === 'General' && roles?.includes('mdd') && user?.mdd?.includes('mddgmr') && user?.mdd?.includes('mmdcd')) {
		return true;
	} else if (companyType === 'Life' && roles?.includes('mdd') && user?.mdd?.includes('mddlmr') && user?.mdd?.includes('mmdcd')) {
		return true;
	} else if (companyType === 'Micro' && roles?.includes('mdd') && user?.mdd?.includes('mddmmr') && user?.mdd?.includes('mmdcd')) {
		return true;
	} else {
		return false;
	}
};

const isAbleAllowEditing = ({ user, companyType }) => {
	// mddgmr
	// mddlmr
	// mddmmr
	// mmdcd
	// mmdrd
	// mddcae
	if (!user) return false;
	if (!companyType) return false;
	const roles = user?.role.split(',') || [];
	if (roles?.includes('admin')) return true;
	if (companyType === 'General' && roles?.includes('mdd') && user?.mdd?.includes('mddgmr') && user?.mdd?.includes('mddcae')) {
		return true;
	} else if (companyType === 'Life' && roles?.includes('mdd') && user?.mdd?.includes('mddlmr') && user?.mdd?.includes('mddcae')) {
		return true;
	} else if (companyType === 'Micro' && roles?.includes('mdd') && user?.mdd?.includes('mddmmr') && user?.mdd?.includes('mddcae')) {
		return true;
	} else {
		return false;
	}
};

export {
	mappingKhmerNumber,
	mappingKhmerNumberDecimal,
	validateSpreadsheet,
	validateSpreadsheets,
	isNumeric,
	checkSelectedActiveRow,
	checkSelectedActiveColumn,
	cleanSpreadsheet,
	saleReportTypes,
	mappingCompanyType,
	mappingTypeOfReport,
	isDataViewer,
	isConViewer,
	isAbleAllowEditing,
};
